
export const midAdsTime = (data)=>(dispatch)=>{
    dispatch({type: "MID_TIME", payload: data});
}

export const videoTime = (data)=>(dispatch)=>{
    dispatch({type: "VID_DURATION", payload: data})
}
